export default {
  name: 'AppLost',
  props: {
    state: { type: Object, required: true }
    // teams: { type: Boolean, required: true },
    // score: { type: Number, required: true },
    // kills: { type: Number, required: true }
  },
  mounted () {
    window.aiptag.cmd.display.push(() => {
      window.aipDisplayTag.refresh('typenconquer-io_300x250')
    })
  }
}
